export default class Anchor {
    static init(): void {
        this.anchors();
        this.previewAnchors();
    }

    static anchors(): void {
        const anchors: NodeListOf<HTMLAnchorElement> = document.querySelectorAll('a[data-anchor]');

        if (anchors.length > 0) {
            anchors.forEach((anchor: HTMLAnchorElement) => {
                anchor.addEventListener('click', (e: MouseEvent) => {
                    e.preventDefault();
    
                    const targetID: string | null = anchor.getAttribute('data-anchor');
                    if (!targetID) return; // Pokud targetID neexistuje, přerušíme funkci
    
                    const targetElement: HTMLElement | null = document.getElementById(targetID);
                    const navbar: HTMLElement | null = document.querySelector('.navbar');
    
                    if (targetElement && navbar) {
                        const navbarHeight: number = navbar.offsetHeight;
                        // Používáme document.documentElement.scrollTop jako alternativu k window.pageYOffset
                        const targetPosition: number = targetElement.getBoundingClientRect().top + document.documentElement.scrollTop - navbarHeight + 50;
    
                        window.scrollTo({ top: targetPosition, behavior: 'smooth' });
                    }
                });
            });
        }
    }

    static previewAnchors(): void {
       // Funkce pro získání výšky elementu, pokud existuje
        const getHeightOfElement = (selector: string): number => {
            const selectedElement = document.querySelector(selector);
            return selectedElement instanceof HTMLElement ? selectedElement.offsetHeight : 0;
        };

        // Získání výšky prvků .navbar a .menu-bar__inner
        const navbarElementHeight = getHeightOfElement('.navbar');
        const menuBarInnerHeight = getHeightOfElement('.menu-bar__inner');

        // Výpočet celkové výšky
        const totalPageOffset = navbarElementHeight + menuBarInnerHeight;

        // Funkce pro úpravu odsazení u #recenze-anchor
        const scrollToAnchorWithOffset = () => {
            if (window.location.hash === '#recenze-anchor') {
                const anchorElement = document.querySelector('#recenze-anchor');
                if (anchorElement instanceof HTMLElement) {
                    const anchorPositionY = anchorElement.getBoundingClientRect().top + window.pageYOffset;
                    
                    // Dočasně odstraníme hash z URL
                    history.replaceState(null, "", window.location.pathname + window.location.search);

                    // Nastavíme timeout pro odložení přesměrování
                    setTimeout(() => {
                        window.scrollTo({
                            top: anchorPositionY - totalPageOffset,
                            behavior: 'smooth'
                        });
                        
                        // Znovu nastavíme hash v URL
                        history.replaceState(null, "", window.location.pathname + window.location.search + '#recenze-anchor');
                    }, 0);
                }
            }
        };

        // Spuštění při načtení stránky
        scrollToAnchorWithOffset();

        // Spuštění při změně hash v URL
        window.addEventListener("hashchange", scrollToAnchorWithOffset);
    }
}